const BathroomIcon = ({ fill = "#31493C" }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8239 10.416V12.816C17.8239 14.5833 16.3911 16.016 14.6239 16.016H6.62383C4.85652 16.016 3.42383 14.5833 3.42383 12.816V10.896C3.42383 10.6309 3.63873 10.416 3.90383 10.416H17.8239Z"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8242 16.0156L14.6242 17.6156"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.42305 16.0156L6.62305 17.6156"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.823 10.416V5.61602C17.823 3.8487 16.3903 2.41602 14.623 2.41602H10.623"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3437 6.41602H7.90366C7.63856 6.41602 7.42678 6.20138 7.45579 5.93786C7.57263 4.87633 8.11413 2.41602 10.6237 2.41602C13.1332 2.41602 13.6747 4.87633 13.7915 5.93786C13.8205 6.20137 13.6088 6.41602 13.3437 6.41602Z"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BathroomIcon;
